import http from "infra/http";
import { useQuery } from "react-query";
import { BancoItem } from "../typings";

function useGetBancos() {
  return useQuery(
    [`/v1/bancos`],
    async () => {
      const { data } = await http.get(
        `/v1/bancos`,
      );

      return data as BancoItem[];
    }
  );
}

export default useGetBancos;
